export interface PresetBlockData {
  id: string;
  title: string;
  description: string;
  blockName?: string;
  blockType: string;
}
